import { render, staticRenderFns } from "./dashboard-operations.vue?vue&type=template&id=77a961fa"
import script from "./dashboard-operations.js?vue&type=script&lang=js&external"
export * from "./dashboard-operations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports